module.exports = __webpack_public_path__ + "images/emoji/six.fd5d54dc47426bec15b8.png";